// @flow strict

import * as React from 'react';
import Header from '../../components/Header';
import CtaText from '../../components/CtaText';
import PartnerBar, { type PartnerType } from './Internal/PartnerBar';
import { MapMarker } from './Internal/MapMarker';
import PardotDialog from '../../internal/PardotDialog';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';

type PartnerProfileTopPropTypes = {|
  fullName: string,
  partnerStatus?: string,
  role?: string,
  companyName?: string,
  location?: string,
  image: string,
  pardotFormTitle: string,
  pardotFormUrl: string,
  partnerType: PartnerType,
  ctaText: string,
  serviceSpecialty: Array<string>,
  industryExperience: Array<string>,
|};

type PartnerProfileBottomPropsTypes = {|
  name: string,
  pardotFormTitle: string,
  pardotFormUrl: string,
|};

const Location = (props: { location: string }) => (
  <span className={styles.location}>
    <MapMarker /> &nbsp;
    {props.location}
  </span>
);

const PartnerProfileTop = (props: PartnerProfileTopPropTypes) => {
  const [dialogOpen, toggleDialog] = React.useState(false);
  const onClick = () => toggleDialog(true);

  return (
    <>
      <Header
        title={props.fullName}
        subtitle={props.partnerStatus}
        image={props.image}
        variant="Dark"
      >
        <>
          {props.role} <br />
          {props.companyName} <br />
          {props.location && <Location location={props.location} />}
        </>
      </Header>
      <PartnerBar
        ctaText={props.ctaText}
        onClick={onClick}
        industryExperience={props.industryExperience}
        serviceSpecialty={props.serviceSpecialty}
        partnerType={props.partnerType}
      />
      {dialogOpen && (
        <PardotDialog
          formTitle={props.pardotFormTitle}
          formUrl={props.pardotFormUrl}
          onToggle={toggleDialog}
        />
      )}
    </>
  );
};

const PartnerProfileBottom = (props: PartnerProfileBottomPropsTypes) => (
  <CtaText
    title="Get in touch"
    firstCtaBtn={{
      text: `Contact ${props.name}`,
      variant: 'Outlined',
      pardotFormUrl: props.pardotFormUrl,
      pardotFormTitle: props.pardotFormTitle,
    }}
    background="Dark"
  >
    {`<p>Find out how ${props.name} could help you with your next financial event</p>`}
  </CtaText>
);

export { PartnerProfileBottom, PartnerProfileTop };
